__turbopack_context__.v({
  "buttonMinimal": "styles-module__wfHRsq__buttonMinimal",
});
